import { userApi } from "@/core/data/api";

export default async (query) => {
  return await userApi.getUserListPagination(query);
};
